'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findResponderByIdFromList = findResponderByIdFromList;
function findResponderByIdFromList(_ref) {
  var responders = _ref.responders,
      responderId = _ref.responderId;

  return responders.find(function (responder) {
    return responder.userId === responderId;
  });
}